import UsersPage from "components/pages/UsersPage";

/**
 * @name CaptureUserList
 * @returns {React.Component}
 * @description 
 */
export default function CaptureUserList(props) {
    return <UsersPage/>;
}